import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../buttons";
import CustomModal from "../modals";
import TypeFormEmbed from "src/containers/typeforms";
// import whitecloudoor from "src/assets/images/whitecloudoor.png";
import ICONS from "src/assets/icons";

const AppHeader: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isVisibleTypeForm, setIsVisibleTypeForm] = React.useState(false);

  // const navItems = [
  //   { label: "Home", path: "/" },
  //   // { label: "Solutions", path: "/solutions" },
  //   // { label: "Case Study", path: "/case-study" },
  //   // { label: "Pricing", path: "/pricing" },
  // ];

  return (
    //fixed top-0 left-0 right-0
    <header className="z-[9999] mt-4 ml-4 mr-4 sm:ml-[3rem] sm:mr-[3rem] mx-auto">
      <nav className="px-2 py-2 border border-[#2D3748] rounded-[10px] bg-[#05132D73] backdrop-blur-[6px]">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-baseline">
            <span className="text-[2.5rem] font-bold text-white">d</span>
            {ICONS.CloudDoorLoop()}
            <span className="text-[2.5rem] font-bold text-white">r</span>
           {/* <img src={whitecloudoor} alt="Door" className="h-6 sm:h-8 md:h-10 lg:h-8 xl:h-8" /> */}
            {/* <span className="text-xl font-bold text-white">DOOR</span> */}
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {/* {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="text-gray-300 hover:text-white transition-colors duration-200"
              >
                {item.label}
              </Link>
            ))} */}
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button
              className="flex xs:h-[40px] sm:h-[40px] md:h-[4px] lg:h-[45px] xl:h-[45px] xs:p-[8px] sm:p-[8px]  md:p-[15px] lg:p-[15px] xl:p-[15px] justify-center items-center gap-[8px] rounded-[12px] [background:var(--main-gradient,linear-gradient(90deg,#145BF0_0%,#1DC66D_100%))]"
              onClick={() => setIsVisibleTypeForm(true)}
            >
              REJOIGNEZ-NOUS <i className="bi bi-arrow-right"></i>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isMenuOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4">
            <div className="flex flex-col space-y-4">
              {/* {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ))} */}
              <Button
                variant="primary"
                className="w-full text-center [background:var(--main-gradient,linear-gradient(90deg,#145BF0_0%,#1DC66D_100%))]"
                onClick={() => setIsVisibleTypeForm(true)}
              >
                REJOIGNEZ-NOUS <i className="bi bi-arrow-right"></i>
              </Button>
            </div>
          </div>
        )}
      </nav>
      {isVisibleTypeForm && (
        <CustomModal
          isOpen={isVisibleTypeForm}
          onClose={() => setIsVisibleTypeForm(false)}
          title=""
        >
          <TypeFormEmbed />
        </CustomModal>
      )}
    </header>
  );
};

export default AppHeader;
